/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */

import { IDropdownOption } from '@fluentui/react/lib/Dropdown';
import { Icon } from '@fluentui/react/lib/Icon';
import { Stack } from '@fluentui/react/lib/Stack';
import { IRenderFunction } from '@fluentui/react/lib/Utilities';
import * as React from 'react';
import { getThemedIcon, IconName } from '../../../resources/icons/Icons';
import { MobileActionTableItem } from '../MobileActionTableItem/MobileActionTableItem';
import { MobileDropdown, MobileDropdownOption } from '../MobileDropdown/MobileDropdown';
import { titleStyles } from './MobileDropdownField.styles';

export interface MobileDropdownFieldProps {
    label: string;
    options: MobileDropdownOption[];
    onChange: (option: MobileDropdownOption) => void;
}

export const MobileDropdownField: React.FC<MobileDropdownFieldProps> = (
    props: MobileDropdownFieldProps
): JSX.Element => {
    const { label, options, onChange } = props;
    const icon = getThemedIcon(IconName.options);

    const onRenderTitle: IRenderFunction<IDropdownOption[]> = (): JSX.Element => {
        const selectedOption = options.find((o: MobileDropdownOption): boolean => o.selected);
        return (
            <Stack horizontal horizontalAlign='space-between'>
                <span>{label}</span>
                <span style={titleStyles}>{selectedOption?.title}</span>
            </Stack>
        );
    };

    const onRenderCaretDown = (): JSX.Element => {
        return <Icon iconName='ChevronRight' />;
    };

    const actionElement = (
        <MobileDropdown
            options={options}
            onChange={onChange}
            onRenderTitle={onRenderTitle}
            onRenderCaretDown={onRenderCaretDown}
        />
    );

    return <MobileActionTableItem unselectedIcon={icon} selectedIcon={icon} actionElement={actionElement} />;
};
